import * as actionTypes from 'src/old/actions';

export const userRoles = Object.freeze({
  GUEST: 'GUEST',
  USER: 'USER',
  ADMIN: 'ADMIN'
});

const initialState = {
  loggedIn: false,
  isSuperAdminSession: false,
  user: {
    email: '',
    role: userRoles.GUEST
  }
};

const setLocalStorage = state => localStorage.setItem('state', JSON.stringify(state));

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SESSION_LOGIN: {
      const newState = {
        ...state,
        loggedIn: true,
        isSuperAdminSession: action.role === userRoles.ADMIN,
        user: {
          ...state.user,
          email: action.email,
          role: action.role
        }
      };

      setLocalStorage(newState);
      return {
        ...newState
      };
    }

    case actionTypes.SESSION_LOGIN_AS: {
      const newState = {
        ...state,
        isSuperAdminSession: state.isSuperAdminSession || state.user.role === userRoles.ADMIN,
        user: {
          ...state.user,
          role: userRoles.USER
        }
      };

      setLocalStorage(newState);
      return {
        ...newState
      };
    }

    case actionTypes.SESSION_LOGOUT: {
      // If we are still loged in as super admin it should pull us back into the super admin
      let newState = {};

      if (state.user.role === userRoles.USER) {
        newState = {
          ...state,
          isSuperAdminSession: true,
          user: {
            ...state.user,
            role: userRoles.ADMIN
          }
        };
      } else {
        newState = {
          ...state,
          loggedIn: false,
          isSuperAdminSession: false,
          user: {
            ...state.user,
            role: userRoles.GUEST
          }
        };
      }

      setLocalStorage(newState);

      return {
        ...newState
      };
    }

    default: {
      return state;
    }
  }
};

export default sessionReducer;
